export default __webpack_public_path__ + "static/media/325.51555a8d.gif";